import React from 'react'

import configRoutes from 'config/routes'

import { LinkWithoutUnderline } from '../MenuAlert/LinkWithoutUnderline'
import { MenuAlert } from '../MenuAlert/MenuAlert'

export const AccountOnHoldAlert = () => (
  <MenuAlert title="Account on hold">
    Your account is currently on hold. Your future orders have been cancelled, and you won&apos;t be
    able to place any new ones until this is resolved. Please update your card details{' '}
    <LinkWithoutUnderline href={`${configRoutes.client.myDetails}#paymentInfo`}>
      here
    </LinkWithoutUnderline>{' '}
    to reactivate your account.
  </MenuAlert>
)
